<template>
  <Modal
    v-model="open"
    class="modal--xlg modal--align-top"
    @input="$emit('closeModal')"
  >
    <template #modal-panel>
      <div>
        <ExpressionEditor v-model="dataValue" />
      </div>
    </template>
  </Modal>
</template>

<script>

import Modal from '#src/components/utils/Modal.vue'
import ExpressionEditor from '#src/components/advanced-search/expression-editor/ExpressionEditor.vue'

export default {
  components: {
    Modal,
    ExpressionEditor
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  emits: ['closeModal', 'update:value'],
  data() {
    return {
      open: false
    }
  },
  computed: {
    canExpressionSearch: function () {
      return this.value.sequence.length > 0 && this.value.isValid
    },
    dataValue: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:value', val)
      }
    }
  },
  watch: {
    showModal: function (value) {
      if (value === true) {
        this.open = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "#src/assets/scss/variables" as *;
</style>
